export const BlogPostType = [
  {
    type: "python",
    text: "Python",
    color: "yellow",
  },
  {
    type: "HTML",
    text: "HTML",
    color: "red",
  },
  {
    type: "conceptos-basicos-de-programacion",
    text: "Conceptos básicos",
    color: "blue",
  },
];
